<template>
  <div>

    <BackButton v-if="$route.name !== 'tenants'" :namedRoutes="{ tenants: $t('nav.tenants'), tenant: $t('common.tenant')}"></BackButton>

    <add-edit-tenant-view v-if="$route.name !== 'tenant' && $route.name !== 'export-tenants-details'" />
    <tenant-details @isDeleted="(boolean) => {isDetailDeleted = boolean}" :tenant="tenant" v-if="$route.name !== 'add-tenant' && $route.name !== 'edit-tenant' && $route.name !== 'export-tenants-details'"/>
    <products-table :tenant="tenant" :products="tenant.products" v-if="!isDetailDeleted && $route.name !== 'add-tenant' && $route.name !== 'edit-tenant' && $route.name !== 'export-tenants-details'"/>
    <products-delayed-table :tenant="tenant" :products="tenant.defferedProducts" v-if="!isDetailDeleted && $route.name !== 'add-tenant' && $route.name !== 'edit-tenant' && $route.name !== 'export-tenants-details'"></products-delayed-table>
    <kiosks-table :kiosks="tenant.kiosks" :tenant="tenant" v-if="!isDetailDeleted && tenant.guestParking && $route.name !== 'add-tenant' && $route.name !== 'edit-tenant' && $route.name !== 'export-tenants-details'"></kiosks-table>
    <accounts-table :accounts="tenant.accounts" :tenant="tenant" v-if="!isDetailDeleted && $route.name !== 'add-tenant' && $route.name !== 'edit-tenant' && $route.name !== 'export-tenants-details'"></accounts-table>
    <users-table :users="tenant.users" :tenant="tenant" v-if="!isDetailDeleted && $route.name !== 'add-tenant' && $route.name !== 'edit-tenant' && $route.name !== 'export-tenants-details'"></users-table>
    <export-tenant-details-form :tenant="tenant" v-if="!isDetailDeleted && $route.name === 'export-tenants-details'" />

    <BackButton v-if="$route.name !== 'tenants'" :namedRoutes="{ tenants: $t('nav.tenants'), tenant: $t('common.tenant')}"></BackButton>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import BackButton from 'common/BackButton';
import AddEditTenantView from './AddEditTenantView';
import TenantDetails from './TenantDetails';
import ProductsTable from './ProductsTable';
import ProductsDelayedTable from './ProductsDelayedTable';
import AccountsTable from './AccountsTable';
import UsersTable from './UsersTable';
import KiosksTable from './KiosksTable';
import ExportTenantDetailsForm from './ExportTenantDetailsForm';

export default {
  components: {
    BackButton,
    AddEditTenantView,
    TenantDetails,
    ProductsTable,
    ProductsDelayedTable,
    AccountsTable,
    UsersTable,
    KiosksTable,
    ExportTenantDetailsForm,
  },
  data() {
    return {
      isDetailDeleted: false,
    };
  },
  computed: {
    routeAcceptsMobileScreen() {
      return typeof this.$route.meta.onMobileScreen === 'object';
    },
    ...mapGetters({
      tenant: 'tenants/tenant/tenant',
      isMobileScreen: 'screen/isMobileScreen',
    }),
  },
  watch: {
    $route: 'fetchTenant',
  },
  route: {
    canReuse: true,
  },
  created() {
    if (!this.user.authenticated) {
      return;
    }

    this.fetchTenant();
  },
  methods: {
    fetchTenant() {
      if (this.$route.params.id && this.user.data) {
        this.$store.dispatch('tenants/tenant/fetch', { id: this.$route.params.id, user: this.user }).then(() => {
        });
      } else {
        this.$store.commit(`tenants/tenant/${mTypes.CLEAR_STATE}`);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tenants/MainView.vue